var _circle, _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _circle2, _path7, _path8, _path9, _circle3, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 172,
    viewBox: "0 0 177 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 84,
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.3845,
    y: 35.9999,
    width: 105.231,
    height: 61.3846,
    rx: 1,
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1952 98.142C31.3065 97.6969 31.7065 97.3846 32.1654 97.3846H135.835C136.293 97.3846 136.693 97.6969 136.805 98.142L140.689 113.681C140.847 114.312 140.37 114.923 139.719 114.923H28.2808C27.6302 114.923 27.1528 114.312 27.3106 113.681L31.1952 98.142Z",
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7693 106.154H132.231",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1538,
    y: 44.7692,
    width: 50.4231,
    height: 33.9808,
    rx: 1,
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5547 58.2059L48.1498 62.6307C47.5177 63.0674 47.5937 64.0241 48.2867 64.3556L54.5547 67.3535",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2458 57.923L83.6507 62.3478C84.2828 62.7845 84.2069 63.7412 83.5138 64.0727L77.2458 67.0706",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9883 57.923L68.2477 67.0706",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 51.3461H88.9327",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 57.6538,
    width: 44,
    height: 32,
    rx: 1,
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.9615,
    cy: 67.5191,
    r: 4.38462,
    fill: "#F2463A",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91 81.0576H115",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65.0576H115",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107 73.0576H115",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.717,
    cy: 106,
    r: 20,
    fill: "#F2463A",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.042 154.373C174.983 156.699 173.086 159 170.577 159H93.0751C90.5664 159 88.6693 156.699 89.6103 154.373C94.9783 141.107 111.847 131.423 131.826 131.423C151.805 131.423 168.674 141.107 174.042 154.373Z",
    fill: "#F2463A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.042 154.373L172.188 155.124L174.042 154.373ZM89.6103 154.373L87.7563 153.623L89.6103 154.373ZM93.0751 161H170.577V157H93.0751V161ZM91.4642 155.124C96.4269 142.859 112.359 133.423 131.826 133.423V129.423C111.335 129.423 93.5296 139.356 87.7563 153.623L91.4642 155.124ZM131.826 133.423C151.293 133.423 167.225 142.859 172.188 155.124L175.896 153.623C170.123 139.356 152.317 129.423 131.826 129.423V133.423ZM170.577 161C174.185 161 177.484 157.547 175.896 153.623L172.188 155.124C172.371 155.577 172.29 155.988 172.022 156.335C171.733 156.707 171.217 157 170.577 157V161ZM93.0751 157C92.4348 157 91.9192 156.707 91.6307 156.335C91.362 155.988 91.2809 155.577 91.4642 155.124L87.7563 153.623C86.1687 157.547 89.4675 161 93.0751 161V157Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAccount);
export default __webpack_public_path__ + "static/media/dashboard-account.4bdafe2c3edc9b77e6b6c33df3e247dd.svg";
export { ForwardRef as ReactComponent };